import React, {FormEvent, memo, ReactNode} from 'react';
import './index.scss';
import {Column, ColumnProps} from '../../Column';
import {Widget} from '../../Widget';
import {onClickHandler} from '../../../utils/onclick';

type Props = {
    name: string;
    click: () => void;
    onChange: (e: FormEvent<HTMLInputElement>) => void;
    value: number;
    children?: ReactNode;
    activeImage: string;
    passiveImage: string;
    columnProps?: Partial<ColumnProps>;
};

export const RangeRawComponent = memo(function RangeRawComponent({name, children, click, value, onChange, activeImage, passiveImage, columnProps}: Props) {
    return (
        <Column min={6} max={12} {...columnProps}>
            <Widget style={{padding: 0}}>
                <div className="position-relative">
                    <div className="range">
                        <div className="range-image-wrapper">
                            <div className="range-image">
                                <div {...onClickHandler(click)}>
                                    <img
                                        src={value === 0 ? passiveImage : activeImage}
                                        alt={name}/>
                                </div>
                            </div>
                        </div>
                        <div className="range-content-wrapper">
                            <div className="range-title">
                                <span>{name}</span>
                            </div>
                            <div className="range-control-value">
                        <span>
                            <span>{value}%</span>
                        </span>
                            </div>
                            <div className="range-slide-control">
                                <input type="range" name="points" value={value} min={0} max={100} step={10}
                                       onChange={onChange}
                                       onInput={onChange}/>
                            </div>
                        </div>
                    </div>
                    {children}
                </div>
            </Widget>
        </Column>
    );
});
